// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__r2bzB","productName":"Table_productName__qzKv8"};